export const PRODUCT_NAME = "Enlighten";
export const CONVERSATION_LENS = "Conversation Lens";
export const CONVERSATION_LENSES = "Conversation Lenses";
export const CONVERSATION_LENS_PACK = "Conversation Lens Pack";
